import { Badge, Text } from '@planningcenter/tapestry-react';
import React from 'react';

const BetaBadge = () => (React.createElement(Badge, { color: "hsla(221, 89%, 93%, 1)", radius: "pill", size: "xs" },
    React.createElement(Text, { color: "hsla(221, 91%, 55%, 1)" }, "Beta")));

export { BetaBadge };
//# sourceMappingURL=beta_badge.js.map
